import { render, staticRenderFns } from "./specialcar.vue?vue&type=template&id=5146c126&scoped=true&"
import script from "./specialcar.vue?vue&type=script&lang=js&"
export * from "./specialcar.vue?vue&type=script&lang=js&"
import style0 from "./specialcar.vue?vue&type=style&index=0&id=5146c126&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5146c126",
  null
  
)

export default component.exports